import Icon from '../components/Icon.vue'

Icon.register({
  'align-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M288 44V84C288 92.8 280.8 100 272 100H16C7.2 100 0 92.8 0 84V44C0 35.2 7.2 28 16 28H272C280.8 28 288 35.2 288 44zM0 172V212C0 220.8 7.2 228 16 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H16C7.2 156 0 163.2 0 172zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM272 284H16C7.2 284 0 291.2 0 300V340C0 348.8 7.2 356 16 356H272C280.8 356 288 348.8 288 340V300C288 291.2 280.8 284 272 284z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/align-left.js
// module id = FNjd
// module chunks = 144